export default __webpack_public_path__ + "static/media/img-001.10ee1357.svg";